import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import useAxiosPrivate from "../../hooks/useAxiosPrivate";

const RemoveParticipant = () => {
  const axiosPrivate = useAxiosPrivate();
  const navigate = useNavigate();
  const [quizid, setQuizid] = useState("");
  const [user, setUser] = useState("");
  const [errMsg, setErrMsg] = useState("");
  const [success, setSuccess] = useState(false);

  useEffect(() => {
    setQuizid(localStorage.getItem("quizid"));
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setErrMsg("");
    setSuccess(false);
    try {
      const response = await axiosPrivate.post(
        "/manager/removeparticipant",
        JSON.stringify({ quizid, user })
      );

      setSuccess(true);
      setUser("");
    } catch (err) {
      console.error(err);
      setErrMsg(err?.response?.data?.message || err?.message);
    }
  };

  return (
    <div className="fade-in" style={{ maxWidth: "600px", margin: "0 auto", padding: "2rem 1rem" }}>
      {/* Back Button */}
      <button
        className="btn-secondary"
        style={{ marginBottom: "1.5rem", padding: "0.5rem 1rem", fontSize: "0.875rem" }}
        onClick={() => navigate("/manager/quizdetails")}
      >
        ← Back to Quiz Details
      </button>

      {/* Header */}
      <div style={{ marginBottom: "2rem", textAlign: "center" }}>
        <h1
          style={{
            fontSize: "2.5rem",
            fontWeight: "700",
            marginBottom: "0.5rem",
            background: "linear-gradient(135deg, var(--error-red), var(--warning-amber))",
            WebkitBackgroundClip: "text",
            WebkitTextFillColor: "transparent",
            backgroundClip: "text",
          }}
        >
          Remove Participant
        </h1>
        <p style={{ color: "var(--text-muted)", fontSize: "1.125rem" }}>
          Remove a user from this quiz session
        </p>
      </div>

      {/* Messages */}
      {errMsg && <p className="errmsg">{errMsg}</p>}
      {success && (
        <div className="successmsg" style={{ textAlign: "center" }}>
          <p style={{ marginBottom: "1rem" }}>✓ Participant removed successfully!</p>
          <button
            className="btn-primary"
            onClick={() => navigate("/manager/quizdetails")}
            style={{ marginTop: "0.5rem" }}
          >
            Back to Quiz Details
          </button>
        </div>
      )}

      {/* Form Card */}
      {!success && (
        <div className="card" style={{ padding: "2.5rem" }}>
          <form onSubmit={handleSubmit}>
            <div className="form-group">
              <label htmlFor="user">Participant Email</label>
              <input
                type="text"
                id="user"
                value={user}
                onChange={(e) => setUser(e.target.value)}
                placeholder="Enter participant's email"
                required
              />
            </div>

            <div style={{ marginTop: "2rem", display: "flex", gap: "1rem" }}>
              <button type="submit" className="btn-danger" style={{ flex: 1 }}>
                Remove Participant
              </button>
              <button
                type="button"
                className="btn-secondary"
                onClick={() => navigate("/manager/quizdetails")}
                style={{ flex: 1 }}
              >
                Cancel
              </button>
            </div>
          </form>
        </div>
      )}
    </div>
  );
};

export default RemoveParticipant;
